// Root URL — server-side redirect by session presence. Authenticated
// requests land on `/live-in-club`; everyone else lands on `/login`. The
// `beforeLoad` hook runs both on initial SSR and on client-side
// navigation; the `typeof window` early-return short-circuits the
// client-side path so `resolveScopeOnServer` is only invoked on the
// server (its body — and the server-only imports it pulls in — is
// excluded from the client bundle by Tanstack Start's import-
// protection plugin).

import { createFileRoute, redirect } from '@tanstack/react-router';
import { createServerOnlyFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { getServerAuthService } from '../bounded-contexts/authentication/composition.server';

const resolveScopeOnServer = createServerOnlyFn(async () =>
	getServerAuthService().resolveTenantScope(getRequest()),
);

export const Route = createFileRoute('/')({
	beforeLoad: async () => {
		if (typeof window !== 'undefined') return;

		const scope = await resolveScopeOnServer();
		throw redirect({ to: scope ? '/live-in-club' : '/login' });
	},
});
